import {commentAxios} from "../commentAxios";

export const getEditingComment = (commentId) => {
    return commentAxios.get(`/comments/${commentId}`);
};
